const Animation = ((($) => {
  let $window;
  let win_height_padded;
  let scrolled;
  let $this;
  let offsetTop;
  let $animationDelay;

  function init() {
    $window = $(window),
    win_height_padded = $window.height() * 1.0,
    $window.on('scroll', revealOnScroll);

    function revealOnScroll() {
      scrolled = $window.scrollTop(),
      win_height_padded = $window.height() * 1.0;

      $('.animated-on-scroll:not(.animated)').each(function() {
        $this = $(this),
        offsetTop = $this.offset().top,
        $animationDelay = $this.data('delay');
        if (scrolled + win_height_padded > offsetTop) {
          if ($this.data('timeout')) {

            $window.setTimeout(function() {
              $(this);
              $this.addClass('animated ' + $this.data('animation'));
            }, parseInt($this.data('timeout'),10));
          }
          else {
            $this.css({
              'animation-delay': $animationDelay,
              '-webkit-animation-delay': $animationDelay,
              'animation-duration': '.7s'
            });
            $this.addClass('animated ' + $this.data('animation'));
          }
        }
      });

      $('.animated-on-scroll.animated').each(function() {
        $this = $(this),
        offsetTop = $this.offset().top;
        if (scrolled + win_height_padded < offsetTop) {
          //$(this).removeClass('animated fadeInUp fadeInLeft fadeInRight');
        }
      });
    }

    revealOnScroll();
  }
  return {
    init,
  };

}))(jQuery);

export default Animation;



// WEBPACK FOOTER //
// ./src/static/js/modules/animation.js